import styled, { css } from "styled-components";

import { RangesIcon, TooltipRanges } from "components/base/Tooltip";
import { media } from "components/styles/breakpoints";

interface IconProps {
  image: string;
}

interface DerivedStatWrapperProps {
  $isDim: boolean;
  $color: string;
}

interface StatRangeWrapperProps {
  $isDim: boolean;
  $color: string;
}

interface StatRangeColorsProps {
  $color: string;
}

const dimMixin = css`
  opacity: 0.2;
`;

export const StatIconWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const StatIcon = styled.div<IconProps>`
  width: 10px;
  height: 10px;
  mask: url(${(props) => props.image}) no-repeat center;
  background-color: white;
`;

export const DerivedStatWrapper = styled.div<DerivedStatWrapperProps>`
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  transition: all 100ms ease-out;
  ${(props) => props.$isDim && dimMixin}
  ${(props) => `color: ${props.$color};`}

  ${media.desktop`
    font-size: 16px;
  `}

  ${StatIcon} {
    ${(props) => `background-color: ${props.$color};`}
  }
`;

export const StatRangeWrapper = styled.div<StatRangeWrapperProps>`
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  transition: all 100ms ease-out;
  ${(props) => props.$isDim && dimMixin}

  ${media.desktop`
    font-size: 16px;
  `}

  color: ${(props) => props.$color};

  ${StatIcon},
  ${RangesIcon} {
    background-color: ${(props) => props.$color};
  }
`;

export const TooltipTotalStat = styled.div`
  font-weight: 600;
  filter: brightness(120%) saturate(120%);
  margin-top: 2px;
`;

export const TotalStatName = styled.span`
  text-transform: uppercase;
`;

export const TooltipStatRangeValues = styled(
  TooltipRanges
)<StatRangeColorsProps>`
  color: ${(props) => props.$color};

  ${StatIcon},
  ${RangesIcon} {
    background-color: ${(props) => props.$color};
  }
`;

export const DerivedStatName = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const ValueWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const beforeValueMixin = css`
  opacity: 0.5;
  text-decoration: line-through;
`;

export const StatValue = styled.div<{ $isBeforeValue?: boolean }>`
  ${(props) => props.$isBeforeValue && beforeValueMixin}
`;

export const StatValueDiff = styled.div``;

export const StatDiffIcon = styled.div``;
